import { persistor } from '../../store';

export const logout = () => {
  persistor.purge();
  window.location.reload();
};
